/**
 * @file: 层板商品手动放置排列布局
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import * as Toolkit from '../../toolkit/index';
import FrontCubeData from '../../frontCubeData/index';
import Utils from '../../utils/util';
import { hasFoldGoods, hasMoreSurface } from '../goods/index';
import { cubeModify } from '../../update/cubeModify';

export default function layoutFree(layoutTask: Array<LayoutTask>): void {
    layoutTask.forEach((task: LayoutTask): void => {
        let layoutCubeIds: Array<CubeId> = CubeTree.getChildCubeIds(task.layerId);

        layoutCubeIds.forEach((cubeId: CubeId): void => {
            /**
             * 干掉商品中的间隔即可
             */
            cubeModify(cubeId, {
                posWidth: 0
            });
        });
    });
}
